import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useParams, Navigate } from "react-router-dom";
import Entry from "@/pages/Entry";
import LangHome from "@/pages/LangHome";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import { LANGS } from "@/config";

// Scroll to top on every route change.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Guard: only sr / it / en are valid languages.
const withLang = (Component) => {
  const Wrapped = () => {
    const { lang } = useParams();
    if (!LANGS.includes(lang)) return <Navigate to="/" replace />;
    return <Component lang={lang} />;
  };
  return <Wrapped />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Entry />} />

          <Route path="/:lang" element={withLang(LangHome)} />

          {/* Level 3 — About (per-language slug) */}
          <Route path="/sr/vise-o-meni" element={<About lang="sr" />} />
          <Route path="/it/su-di-me" element={<About lang="it" />} />
          <Route path="/en/about" element={<About lang="en" />} />

          {/* Contact (per-language slug) */}
          <Route path="/sr/kontakt" element={<Contact lang="sr" />} />
          <Route path="/it/contatto" element={<Contact lang="it" />} />
          <Route path="/en/contact" element={<Contact lang="en" />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
